<template>
    <div class="page_ mobile_ md_">
        <img class="banner_" src="~@/assets/quote/2.jpg">
        <div class="p_content_">
            <div class="top_">Aon-MediLink SME Plan 报价器-{{planValue=='2'?'大中华':planValue=='3'?'全球除美':'全球'}}</div>
            <a-form class="horizontal_item_ label_w1_">
                <a-form-item label="报价公司名称">
                    <a-input v-model="formInfo.name" placeholder="请输入准确名称"></a-input>
                </a-form-item>
                <a-form-item label="参团员工数">
                    <a-input-number  v-model="formInfo.number" style="width:100%" @change="handleCalcPlanPremium" :min="3" placeholder="参团员工数"></a-input-number>
                </a-form-item>
                <a-form-item label="期望生效日期">
                    <a-date-picker @change="onChangeDate" placeholder="请选择生效日期"  v-model="formInfo.effectiveDate" :disabledDate="disabledDate" style="width:100%"/>
                </a-form-item>
            </a-form>
            <div class="title_ bold_" style="display:flex;justify-content:space-between">保障详情<span @click="showDuty=!showDuty">{{showDuty==true?'收起':'展开'}}</span></div>
            <dutyIntro v-if="showDuty" :planValue="planValue"></dutyIntro>
            <div class="title_ bold_">保障方案选择</div>
            <div v-for="(item, index) in planList" class="section_">
                <div class="s_title_">
                    <a-icon v-if="index > 0" @click="handleSubPlan(index)" class="left_" type="minus"></a-icon>
                    <a-input v-model="item.planName" style="background-color:transparent;border:none;color:#fff;outline:0;text-align:center"></a-input> 
                    <label @click="item.unexpand = !item.unexpand,planList = [...planList]" class="right_">
                    {{item.unexpand? '展开':'收起'}} <a-icon :type="item.unexpand ? 'down' : 'up'">
                    </a-icon></label>
                </div>
                <a-form v-show="!item.unexpand" class="horizontal_item_ form_ label_w2_">
                <a-form-item class="bold_lable_" label="基本计划">
                    <a-select @change="handleCalcPlanPremium()" v-model="item.basicPlanValue">
                        <a-select-option key="0" value="0">大中华Greater China</a-select-option>
                        <a-select-option key="1" value="1">大中华加强Greater China Plus</a-select-option>
                        <a-select-option key="2" value="2">全球除美Worldwide Excluding USA</a-select-option>
                        <a-select-option key="3" value="3">全球除美加强Worldwide Excluding USA Plus</a-select-option>
                        <a-select-option key="4" value="4">全球Worldwide</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item class="bold_lable_" label="门诊精神疾病保障">
                    <a-select @change="handleCalcPlanPremium()" v-model="item.outpatientMental">
                        <a-select-option key="0" value="0">不包含</a-select-option>
                        <a-select-option key="1" value="1">包含</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item class="bold_lable_" label="全球紧急救援">
                    <a-select @change="handleCalcPlanPremium()" v-model="item.emergencyRescue">
                        <a-select-option key="0" value="0">不包含</a-select-option>
                        <a-select-option key="1" value="1">包含</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item class="bold_lable_ mrg_t12_" label="基础保障费率"></a-form-item>
                <a-row class="t_header_" :gutter="8">
                    <a-col :span="8">
                        
                    </a-col>
                    <a-col :span="8">
                        保费
                    </a-col>
                    <a-col :span="8">
                        数目
                    </a-col>
                </a-row>
                <a-row v-for="(p, index) in item.insuredList" class="t_td_" :gutter="8">
                    <a-col :span="8">
                        <span>{{p.type}}</span>
                    </a-col>
                    <a-col :span="8">
                        <span>{{p.basicCale}}</span>
                    </a-col>
                    <a-col :span="8">
                        <a-input  v-model="p.num" 
                            @blur="handleCalcPlanPremium()" 
                            placeholder="请输入"></a-input>
                    </a-col>
                </a-row>
                <a-form-item class="bold_lable_ mrg_t12_" label="可选福利报价">
                  </a-form-item>
                  <a-form-item class="bold_lable_" label="牙科额度">
                      <a-select @change="handleCalcPlanPremium()" v-model="item.dentalQuota">
                          <a-select-option key="0" value="0">4,000</a-select-option>
                          <a-select-option key="1" value="1">9,600</a-select-option>
                          <a-select-option key="2" value="2">无</a-select-option>
                      </a-select>
                  </a-form-item>
                  <a-row class="t_header_" :gutter="8">
                      <a-col :span="8">
                        
                      </a-col>
                      <a-col :span="8">
                          保费
                      </a-col>
                      <a-col :span="8">
                          数目
                      </a-col>
                  </a-row>
                  <a-row v-for="(p, index) in item.dentalList" class="t_td_" :gutter="8">
                    <a-col :span="8">
                        <span>{{p.type}}</span>
                    </a-col>
                    <a-col :span="8">
                        <span>{{p.premium}}</span>
                    </a-col>
                    <a-col :span="8">
                        <a-input  v-model="p.num" 
                            @blur="handleCalcPlanPremium()" 
                            placeholder="请输入"></a-input>
                    </a-col>
                </a-row>
                <a-form-item class="bold_lable_" label="体检额度">
                    <a-select @change="handleCalcPlanPremium()" v-model="item.examinationQuota">
                        <a-select-option key="0" value="0">3,200</a-select-option>
                        <a-select-option key="1" value="1">无</a-select-option>
                    </a-select>
                </a-form-item>
                <a-row class="t_header_" :gutter="8">
                    <a-col :span="8">
                        
                    </a-col>
                    <a-col :span="8">
                        保费
                    </a-col>
                    <a-col :span="8">
                        数目
                    </a-col>
                </a-row>
                <a-row v-for="(p, index) in item.examinationList" class="t_td_" :gutter="8">
                    <a-col :span="8">
                        <span>{{p.type}}</span>
                    </a-col>
                    <a-col :span="8">
                        <span>{{p.premium}}</span>
                    </a-col>
                    <a-col :span="8">
                        <a-input  v-model="p.num" 
                            @blur="handleCalcPlanPremium()" 
                            placeholder="请输入"></a-input>
                    </a-col>
                </a-row>
                <a-form-item class="bold_lable_" label="眼科额度">
                    <a-select @change="handleCalcPlanPremium()" v-model="item.eyeQuota">
                        <a-select-option key="0" value="0">2,400</a-select-option>
                        <a-select-option key="1" value="1">无</a-select-option>
                    </a-select>
                </a-form-item>
                <a-row class="t_header_" :gutter="8">
                    <a-col :span="8">
                        
                    </a-col>
                    <a-col :span="8">
                        保费
                    </a-col>
                    <a-col :span="8">
                        数目
                    </a-col>
                </a-row>
                <a-row class="t_td_" :gutter="8" v-for="(p, index) in item.eyeList">
                    <a-col :span="8">
                        <span>{{p.type}}</span>
                    </a-col>
                    <a-col :span="8">
                        <span>{{p.premium}}</span>
                    </a-col>
                    <a-col :span="8">
                        <a-input  v-model="p.num" 
                            @blur="handleCalcPlanPremium()" 
                            placeholder="请输入"></a-input>
                    </a-col>
                </a-row>
                </a-form>
                <!-- 最多新增3个 -->
                <div v-if="index == planList.length - 1 && planList.length < 3" 
                    @click="handleAddPlan" class="btn_add_">
                    <a-icon type="plus"></a-icon>新增保障计划</div>
            </div>
            <div class="section_">
                <a-form class="horizontal_item_ label_w1_">
                    <a-row class="t_td_ t_footer_" :gutter="8">
                        <a-col :span="12">
                            医疗险报价总计
                        </a-col>
                        <a-col :span="12">
                            {{formInfo.totalPremium}}元
                        </a-col>
                    </a-row>
                </a-form>
            </div>
            <div class="title_ bold_">保司品牌选择</div>
            <a-form class="horizontal_item_ label_w1_">
                <a-form-item label="承保公司">
                    <a-select v-model="formInfo.companyName" default-value="0">
                            <a-select-option v-for="itemc in companyList" :key="itemc" :value="itemc">{{itemc}}</a-select-option>
                    </a-select>
                </a-form-item>
                 <span class="prompt_">上海地区客户请优先选择天安和上海人寿，其他地区客户请优先选择利宝。</span>
                <a-form-item  label="承保条件">
                    <a-select @change="handleCalcPlanPremium()" v-model="formInfo.preExistingDisease">
                        <a-select-option key="0" value="0">既往症限额8,000</a-select-option>
                        <a-select-option key="1" value="1">既往症限额15,000</a-select-option>
                        <a-select-option key="2" value="2">承担一般，重大个核</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="佣金比例">
                    <a-select v-model="formInfo.rate" @change="handleCalcPlanPremium">
                      <a-select-option key="0" value="0">15%</a-select-option>
                      <a-select-option key="1" value="1">18%</a-select-option> 
                    </a-select>
                </a-form-item>
                <a-form-item label="费率上浮系数">
                    <a-input v-model="formInfo.addRate" @blur="checkRate"   placeholder="整体上涨10%，则应输入1.1"></a-input>
                </a-form-item>
                <span class="prompt_">示例：整体上涨10%，则应输入1.1</span>
            </a-form>
            <productIntro :planValue="planValue"></productIntro>
            <div  class="footer_">
                <a-checkbox @change="e => changeCheck(e)" 
                    :checked="agreed" class="checkbox_ blue_checkbox_"></a-checkbox>
                    我已阅读并知晓投保须知及《保险条款》内容
                <div>
                    <button @click="handleToPreview" class="btn_">生成报价书</button>
                </div>
            </div>
        </div>
        <div class="fixbg1" v-if="isLoagding">
            <a-spin />
        </div>
        <div class="fix_btn"  @click="showPlanSelect=true">
            更改保障区域
        </div>
        <div class="fix_sel" v-if="showPlanSelect">
            <div class="con_">
                <p>请选择保障区域</p>
                <span class="close_btn" @click="showPlanSelect=false"></span>
                <div class="sel_con">
                    <div class="item_" v-for="item in planSelect" @click="selectPlan(item.value)" :class="{on:planValue==item.value}">{{item.name}}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.page_ {
    .p_content_ {
        padding: 0 12px;
    }
    .banner_ {
        width: 100%;
        height: auto;
        margin-bottom: 12px;
    }

    .footer_ {
        margin-top: 16px;
        padding-bottom: 50px;
        .checkbox_ {
            margin-right: 6px;
        }
        .btn_ {
            background-color: rgb(24, 144, 255);
            border: none;
            color: #fff;
            margin-top: 8px;
            line-height: 28px;
            border-radius: 6px;
            &:focus {
                outline: none;
            }
        }
    }
    .border_ {
        border: 1px solid #eee;
        padding: 6px;
        border-radius: 12px;
        &.mrg_ {
            margin: 12px 0;
        }
    }
    .mrg_t12_ {
        margin-top: 12px;
    }
    .top_ {
        margin-bottom: 8px;
    }
    .title_ {
        border-left: 3px solid rgb(61, 94, 213);
        padding-left: 6px;
        margin: 18px 0 8px;
    }
    .s_title_ {
        line-height: 32px;
        background-color: rgb(61, 94, 213);
        color: #fff;
        border-radius: 12rpx;
        text-align: center;
        position: relative;
        .left_ {
            position: absolute;
            left: 24px;
            top: 50%;
            transform: translateY(-50%);
            z-index:5
        }
        .right_ {
            position: absolute;
            right: 12px;
            font-size: 12px;
        }
    }
    .section_ {
        margin-top: 12px;
        .form_ {
            border: 1px solid #eee;
            padding: 8px;
        }
        .t_header_ {
            text-align: center;
            margin-bottom: 6px;
        }
        .t_td_ {
            text-align: center;
            line-height: 32px;
            margin-bottom: 8px;
            &.t_footer_ {
                font-weight: 500;
                color: rgb(61, 94, 213);
            }
        }
    }
    .btn_add_ {
        margin: 8px 0;
        color: rgb(61, 94, 213);
        text-decoration: underline;
        font-size: 12px;
    }
}
.fixbg1 {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 99999;
  right: 0;
  background-color: rgba(255, 255, 255, 0.5);
  .ant-spin-spinning {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    left: 0;
    margin: auto;
  }
}
.check_label{
    display:flex;
    align-items:center;
    cursor:pointer;
    color:#999;
    label{
        width:18px;
        height:18px;
        border:1px solid #d9d9d9;
        display:inline-block;
        margin-right:5px;
        background-color:#999;
    }
    &.on{
        color:#333;
        label{
            background-color:#fff;
        } 
    }
    &.checked{
        label{
            background:url(../../assets/quote/checkiconr.png) center center no-repeat #3d5ed5;
            background-size:15px 15px;
            border-color:#3d5ed5;
        }
    }
}
.fix_sel{
    position:fixed;
    top:0;
    left:0;
    right:0;
    bottom:0;
    background-color:rgba(0, 0, 0, 0.5);
    z-index:10;
    .con_{
        position:absolute;
        top:50%;
        transform:translateY(-50%);
        left:0;
        right:0;
        width:90%;
        margin:0 auto;
        background-color:#fff;
        border-radius:5px;
        padding:15px;
        >p{
            font-weight:bold;
            text-align:center;
            padding-bottom:10px;
            margin-bottom:0;
            font-size:15px;
        }
        .close_btn{
            position:absolute;
            top:10px;
            right:10px;
            display:block;
            width:25px;
            height:25px;
            background:url(../../assets/quote/closeicon.png) center center no-repeat;
            background-size:25px 25px;
        }
        .sel_con{
            .item_{
                text-align:center;
                padding:5px 0;
                font-size:14px;
                &.on{
                    color:#3d5ed5
                }
            }
        }
    }
}
.line_{
    height:1px;
    background-color:#efefef;
    margin-bottom:15px;
    margin-top:15px;
}
.fix_btn{
    position:fixed;
    right:5px;
    top:30vh;
    z-index:3;
    writing-mode:vertical-rl;
    background-color:#3d5ed5;
    color:#fff;
    display:block;
    text-align:center;
    padding:15px 8px;
    border-radius:5px; 
    line-height:20px;
    cursor: pointer;
}
.prompt_{
    padding-left:90px;
    font-size:13px;
    display:inline-block;
}
</style>
<script>
import productIntro from './components/productIntroMC';
import dutyIntro from './components/dutyIntroGCW';
import api from '@/utils/api';
import wxAbout from '@/utils/wxAbout';
import moment from "moment";

const typeOptions = [
    '单人', '夫妇', '亲子', '家庭',
];
const premiumRules = [
    [18360, 20195,24479,26927,40798,16851,18536,21286,23414,35476],
    [38547,42402,51396,56536,85659,35381,38919,44692,49161,74486],
    [34875,38362,46498,51148,77497,32009,35210,40433,44476,67388],
    [55086,60594,73448,80793,122411,53222,58544,63867,70254,106444],
];
const dentalPremiumRules = [
    [2103,4018,4019,5702], [4411,8483,8483,12020]
];
const examinationPremiumRules = [
    2483,4773,4773,6803
]
const eyePremiumRules = [
    1237,2456,2456,3571
]
export default {
    data () {
        document.title = 'Aon-MediLink SME Plan 报价器';
        console.log('data -> ', this.$route)
        return {
            planDesc: [{
                unexpand: false
            }, {

            }],
            typeOptions,
            planIndex: undefined,
            planList: [{
                planName:'计划1',
                unexpand:false,
                basicPlanValue:'0',//基本计划
                outpatientMental:'0',//门诊精神疾病保障
                emergencyRescue:'0',//全球紧急救援
                insuredList:[{type:'单人',basicCale:0,num:'0'},{type:'夫妇',basicCale:0,num:'0'},{type:'亲子',basicCale:0,num:'0'},{type:'家庭',basicCale:0,num:'0'},],
                premium: 0,
                dentalQuota:'2',//牙科额度
                examinationQuota:'1',//体检额度
                eyeQuota:'1',//眼科额度
                dentalList:[
                    {
                        type:'单人',
                        num:'0',
                        premium:'0',
                    },
                    {
                        type:'夫妇',
                        num:'0',
                        premium:'0',
                    },
                    {
                        type:'亲子',
                        num:'0',
                        premium:'0',
                    },
                    {
                        type:'家庭',
                        num:'0',
                        premium:'0',
                    },
                ],
                examinationList:[
                   {
                        type:'单人',
                        num:'0',
                        premium:'0',
                    },
                    {
                        type:'夫妇',
                        num:'0',
                        premium:'0',
                    },
                    {
                        type:'亲子',
                        num:'0',
                        premium:'0',
                    },
                    {
                        type:'家庭',
                        num:'0',
                        premium:'0',
                    }, 
                ],
                eyeList:[
                   {
                        type:'单人',
                        num:'0',
                        premium:'0',
                    },
                    {
                        type:'夫妇',
                        num:'0',
                        premium:'0',
                    },
                    {
                        type:'亲子',
                        num:'0',
                        premium:'0',
                    },
                    {
                        type:'家庭',
                        num:'0',
                        premium:'0',
                    }, 
                ],
            }],
            formInfo: {
                name:'',//报价公司名称
                number:'3',//参团员工数
                rate:"0",//期望佣金
                addRate:'1',//费率上浮系数
                totalPremium:0,
                companyName:'利宝保险有限公司',
                effectiveDate:null,
                preExistingDisease:'0',//既往症条件
            },
            agreed: false,
            isLoagding:false,
            checkflag:false,
            showPlanSelect:false,
            planSelect:[
                {
                    name:'中国大陆计划1',
                    value:'0'
                },
                {
                    name:'中国大陆计划2',
                    value:'1'
                },{
                    name:'大中华',
                    value:'2'
                },{
                    name:'全球除美',
                    value:'3'
                },{
                    name:'全球',
                    value:'4'
                }
            ],
            planValue:'2',
            companyList:['利宝保险有限公司','天安财险保险股份有限公司','上海人寿保险股份有限公司'],
            showDuty:false
        }
    },
    components: {
        productIntro,
        dutyIntro
    },
    mounted () {
        const{planValue}=this.$route.query
        this.planValue=planValue?planValue:'2'
    },
    methods: {
        moment,
        selectPlan(value){
            this.planValue=value
            this.showPlanSelect=false
            if(parseInt(value)<2){
                this.$router.push({
                    name: 'medilinkAonMC',
                    query:{
                        planValue:value
                    }
                })
            }
        },
        handleSubPlan (index) {
            this.planList.splice(index, 1);
            this.handleCalcPlanPremium()
        },
        initShare () {
            const options = {
                title: `Aon-MediLink SME Plan 报价器-`+this.planValue=='2'?'大中华':this.planValue=='3'?'全球除美':'全球', // 分享标题
                desc: this.formInfo && this.formInfo.name || '',
                link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: `${location.origin}/pcmall/img/1.jpeg`, // 分享图标
                success: function () {
                    // 设置成功
                }
            };
            wxAbout.fetchJsSdkSign('wxShare', options);
        },
        collectData (arr, report) {
            this.summaryReport = this.summaryReport || [];
            this.summaryReport.push(arr.join(' '));
            if (report) {
                console.group(this.summaryReport.join(';\n'));
                this.summaryReport = [];
            }
        },
        checkRate(){
            if(!this.formInfo.addRate){
                this.formInfo.addRate=1
            }else{
                this.formInfo.addRate=parseFloat(this.formInfo.addRate).toFixed(2)
            }
            this.handleCalcPlanPremium()
        },
        calcPremium (params = {}, formInfo = {}) { 
            let {
                basicPlanValue = 0, //基本计划
                outpatientMental = 0, //门诊精神疾病保障
                emergencyRescue = 0, //全球紧急救援
            } = formInfo;
            const { index = 0 } = params; // 此处age为年龄段的索引
            const row = premiumRules[index];
            let indexCale = 0;
            if(this.formInfo.number<5){
                indexCale = parseInt(basicPlanValue)
            }else{
                indexCale = parseInt(basicPlanValue)+5
            }
            let value = row[indexCale];
            if(this.formInfo.rate == 1){
                this.collectData([
                    '佣金提至18%单人基础价格',
                    `${value}* 105/100`, 'column:', indexCale
                ])
                value=value * 105/100;
            }
            if(this.formInfo.addRate){
                this.collectData([
                    '费率上浮系数至'+this.formInfo.addRate+'单人价格',
                    `${value}* parseFloat(this.formInfo.addRate)`, 'column:', indexCale
                ])
                value=value * parseFloat(this.formInfo.addRate)
            }
            if(outpatientMental == 0){
                this.collectData([
                    '不附加门诊精神疾病保障',
                    `${value}* 92/100`, 'column:', indexCale
                ])
                value=value * 92/100;
            }
            if(emergencyRescue == 0){
                this.collectData([
                    '不附加紧急救援',
                    `${value}* 90/100`, 'column:', indexCale
                ])
                value=value * 90/100;
            }
            if(this.formInfo.preExistingDisease == 0){
                this.collectData([
                    '附加既往症限额3000',
                    `${value}* 85/100`, 'column:', indexCale
                ])
                value=value * 85/100;
            }else if(this.formInfo.preExistingDisease == 1){
                 this.collectData([
                    '附加既往症限额5000',
                    `${value}* 90/100`, 'column:', indexCale
                ])
                value=value * 90/100;
            }
            value=Math.ceil(value)
            return value;
        },
        taAddQuotationData () {
            if (!this.agreed) {
                this.$message.info('请勾选“我已阅读并知晓投保须知”');
                return Promise.reject();
            }
            let arr=[]
            this.planList.map(item=>{
                if(item.insuredList.filter(item1=>item1.num=='0').length==4){
                   this.$message.info('请填写'+item.planName+'的基本计划人数'); 
                   return
                }else{
                    arr.push(item)
                }
            })
            if(this.formInfo.number<=3&&this.planList.length>1){
                this.$message.info('3名员工团体最多可投保一个计划保障方案'); 
                return
            }
            if(this.formInfo.number>=4&&this.formInfo.number<=10&&this.planList.length>2){
                this.$message.info('4-10名员工团体最多可投保两个计划保障方案'); 
                return
            }
            if(this.formInfo.number>10&&this.planList.length>3){
                this.$message.info('超过10名员工团体最多可投保三个计划保障方案'); 
                return
            }
            const effectiveDate=moment(this.formInfo.effectiveDate).format('YYYY-MM-DD')
            let postData={
                ...this.formInfo,
                quotationRiskList:arr,
                effectiveDate:effectiveDate,
            }
            this.isLoagding=true
            console.log(JSON.stringify(postData),'postData====>')
            api.smeGCWWWEWWCreatMediLinkPdf(postData).then(res => res.data).then(data => {
                this.isLoagding=false
                if(data.returnCode=='0'){
                    window.location.href=data.returnUrl     
                }else{
                    this.$message.error(data.returnMsg);
                }
            })
        },
        handleCalcPlanPremium () {
            if (this.stc) {
                clearTimeout(this.stc);
                this.stc = null;
            }
            this.stc = setTimeout(() => {
                let rate=1
                let addRate=1
                if(this.formInfo.rate == 1){
                    rate=1.05
                }
                if(this.formInfo.addRate){
                    addRate = parseFloat(this.formInfo.addRate)
                }
                this.planList.map(item1=>{
                    let plan=item1
                    let totalPremium = 0;
                    plan.insuredList.forEach((item,index1) => {
                        let iNum=0
                        if (item.num) {
                            iNum = Math.round(item.num);
                        }
                        const amount = this.calcPremium({
                            index: index1
                        }, plan);
                        plan.insuredList[index1].basicCale=this.thousandBitSeparator(amount);
                        totalPremium += amount * iNum;
                    });
                    plan.dentalList.forEach((item,index)=>{
                        if(plan.dentalQuota!=2){
                            let indexRow=dentalPremiumRules[parseInt(plan.dentalQuota)]
                            let iNum=0
                            if (item.num) {
                                iNum = Math.round(item.num);
                            }
                            let value=indexRow[index]
                            let premium=Math.ceil(value*rate*addRate)* iNum;
                            let premium1=Math.ceil(value*rate*addRate);
                            plan.dentalList[index].premium=this.thousandBitSeparator(premium1)
                            totalPremium += premium
                        }else{
                            plan.dentalList[index].premium=0
                        }
                    })
                    plan.examinationList.forEach((item,index)=>{
                        if(plan.examinationQuota!=1){
                            let value=examinationPremiumRules[index]
                            let iNum=0
                            if (item.num) {
                                iNum = Math.round(item.num);
                            }
                            let premium=Math.ceil(value*rate*addRate) * iNum;
                            let premium1=Math.ceil(value*rate*addRate);
                            plan.examinationList[index].premium=this.thousandBitSeparator(premium1)
                            totalPremium += premium;
                        }else{
                            plan.examinationList[index].premium=0
                        }
                    })
                    plan.eyeList.forEach((item,index)=>{
                        if(plan.eyeQuota!=1){
                            let value=eyePremiumRules[index]
                            let iNum=0
                            if (item.num) {
                                iNum = Math.round(item.num);
                            }
                            let premium=Math.ceil(value *rate*addRate)* iNum;
                            let premium1=Math.ceil(value*rate*addRate);
                            plan.eyeList[index].premium=this.thousandBitSeparator(premium1)
                            totalPremium += premium;
                        }else{
                            plan.eyeList[index].premium=0
                        }
                    })
                    plan.premium = parseInt(Math.ceil(totalPremium));
                    plan.insuredList = [...plan.insuredList];
                })
                this.sumAllPlanData();
            }, 500);
            
        },
        sumAllPlanData () {
            let totalPremium = 0;
            this.planList.forEach(item => {
                totalPremium += parseFloat(item.premium);
            });
            totalPremium=this.thousandBitSeparator(totalPremium)
            this.formInfo = {
                ...this.formInfo,
                totalPremium,
            };
        },
        handleAddPlan () {
            this.planList.push({
               planName:'计划'+(this.planList.length+1),
                unexpand:false,
                basicPlanValue:'0',//基本计划
                outpatientMental:'0',//门诊精神疾病保障
                insuredAmount:'0',//保额提升至100万
                emergencyRescue:'0',//全球紧急救援
                insuredList:[{type:'单人',basicCale:0,num:'0'},{type:'夫妇',basicCale:0,num:'0'},{type:'亲子',basicCale:0,num:'0'},{type:'家庭',basicCale:0,num:'0'},],
                premium: 0,
                dentalQuota:'2',//牙科额度
                examinationQuota:'1',//体检额度
                eyeQuota:'1',//眼科额度
                dentalList:[
                    {
                        type:'单人',
                        num:'0',
                        premium:'0',
                    },
                    {
                        type:'夫妇',
                        num:'0',
                        premium:'0',
                    },
                    {
                        type:'亲子',
                        num:'0',
                        premium:'0',
                    },
                    {
                        type:'家庭',
                        num:'0',
                        premium:'0',
                    },
                ],
                examinationList:[
                   {
                        type:'单人',
                        num:'0',
                        premium:'0',
                    },
                    {
                        type:'夫妇',
                        num:'0',
                        premium:'0',
                    },
                    {
                        type:'亲子',
                        num:'0',
                        premium:'0',
                    },
                    {
                        type:'家庭',
                        num:'0',
                        premium:'0',
                    }, 
                ],
                eyeList:[
                   {
                        type:'单人',
                        num:'0',
                        premium:'0',
                    },
                    {
                        type:'夫妇',
                        num:'0',
                        premium:'0',
                    },
                    {
                        type:'亲子',
                        num:'0',
                        premium:'0',
                    },
                    {
                        type:'家庭',
                        num:'0',
                        premium:'0',
                    }, 
                ],
            })
        },
        onChangeDate(date, dateString){
            console.log(this.formInfo.effectiveDate,'===>')
        },
        disabledDate(currentDate){
            return currentDate&&(currentDate<moment())
        },
        thousandBitSeparator(num) {
            var num = (num || 0).toString(), result = '';
            while (num.length > 3) {
                result = ',' + num.slice(-3) + result;
                num = num.slice(0, num.length - 3);
            }
            if (num) { result = num + result; }
            return result;
        },
        handleToPreview () {
            if (!this.formInfo.name) {
                try {
                    window.scrollTo(0, 0)
                } catch (error) {
                }
                this.$message.info('请填写客户名称');
                return
            }
            if (!this.formInfo.number) {
                try {
                    window.scrollTo(0, 0)
                } catch (error) {
                }
                this.$message.info('请输入参团员工数');
                return
            }
            this.taAddQuotationData()
        },
        changeCheck(e){
            this.agreed = e.target.checked
            const effectiveDate=moment(this.formInfo.effectiveDate).format('YYYY-MM-DD')
            let postData={
                ...this.formInfo,
                quotationRiskList:this.planList,
                effectiveDate:effectiveDate,
            }
            console.log(JSON.stringify(postData),'postData====>')
        }
    }
}
</script>